import { render, staticRenderFns } from "./ProfileDetails.vue?vue&type=template&id=0061fd85&"
import script from "./ProfileDetails.vue?vue&type=script&lang=ts&"
export * from "./ProfileDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports